<template>
  <course-video-uploader
    :value="video"
    @input="onInput"
    :isDragging="isDragging"
    :showSettingPreview="showSettingPreview"
  />
</template>

<script>
import CourseVideoUploader from "shared/widgets/upload/video/CourseVideoUploader.vue";

export default {
  name: "VideoBlock",
  components: { CourseVideoUploader },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isDragging: {
      type: Boolean,
      required: false,
    },
    showSettingPreview: Boolean,
  },
  data() {
    return {
      video: this.value,
    };
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update");
    },
  },
};
</script>
